/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useState } from 'react';
// material
import { Control, TextField } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from 'material/community/timeframe/timeframe_styles';



/* ========== ~~~~~~~~~~ ADD-ON COMMUNITY TOP ARTICLES : TIMEFRAME ~~~~~~~~~~ ========== */
const Timeframe = props => {

    const [currentTimeframeDays, setCurrentTimeframeDays]  = useState(props.data.topArticlesDaysTimeFrame.value);

    const validateCustomTime = e => {
        props.onChange({
            ...props.data.topArticlesDaysTimeFrame,
            valid: !!e.target.value || e.target.value === 0
        })
    }

    const selectedTimeframe = () => (
        props.data.topArticlesDaysTimeFrame.value === 0 ? 'alltime' : 'custom'
    );

    const handleSelectTimeFrame = value => {
        const timeFrameDays = value === 'alltime' ? 0 : (currentTimeframeDays > 0 ? currentTimeframeDays : 5);
        props.onChange({
            valid: true,
            value: timeFrameDays
        });
    }

    const handleChangeCustomTimeFrameDays = value => {
        const numberValidTest = /^[0-9]{0,3}$/;
        if(!numberValidTest.test(value)) return;
        setCurrentTimeframeDays(value);
        props.onChange({
            valid: true,
            value
        });
    }

    return (
        <div className={`timeframe ${props.classes.timeframe} section`}>
            <div className={`sectioncontent`}>
                <Control 
                    text={'All time'} 
                    value={'alltime'}
                    handleSelect={handleSelectTimeFrame} 
                    variant={'secondary'} 
                    addCheckWhenSelected={true}
                    selected={selectedTimeframe() === 'alltime'}  
                />
                <Control 
                    text={'Custom time'} 
                    value={'custom'} 
                    handleSelect={handleSelectTimeFrame} 
                    variant={'secondary'} 
                    addCheckWhenSelected={true}
                    selected={selectedTimeframe() === 'custom'}  
                />
                { selectedTimeframe() === 'custom' &&
                    <div className={'daysfield'}>
                        <span>Last</span>
                        <TextField 
                            name={'customTime'}
                            type={'text'}
                            required={true}
                            valid={props.data.topArticlesDaysTimeFrame.valid}
                            value={props.data.topArticlesDaysTimeFrame.value}
                            handleBlur={validateCustomTime}
                            handleChange={e => handleChangeCustomTimeFrameDays(e.target.value)} 
                        />
                        <span>day(s)</span>
                    </div>
                }
            </div>
        </div>
    )
}

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Timeframe);